import { useItemsContext } from "@/@presentation/contexts/schedulesContext";
import { Modal, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Notification } from '@presentation/components/common';
import { Button } from "../Button";
import {Modal as AntModal, Typography} from 'antd';
import {Button as AntdButton} from 'antd'
import {Payer} from '@/@presentation/modules/schedule/pages/home/payer';
import customer from '@/@core/modules/customer/infra/container.registry';
import money from "@/@core/modules/common/infra/money";
import date from '@core/modules/common/infra/date';
import {formatStatus, formatTaxNoteNumber} from "@/@core/modules/schedule/domain/schedule.entities";
import cataGadp from '@/@core/modules/validateCataGadp/infra/container.registry';
import { useBusinessPartner } from '@/@presentation/hooks/useBusinessPartner';
import { getNotFoundMessage } from '@/@presentation/constants/businessPartnerMessages';
import { normalizeCnpj, isCnpjLength } from '@/@core/utils/cnpj.utils';

const ButtonsBar = (props: {
    selectedItems: any[]
    nfNumber: number
    setSelectedItems: React.Dispatch<React.SetStateAction<any[]>>
    removeItem: (id: any, callback?: 'nf' | 'payment' | '') => void
    executeFunction?: string
}) => {
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false)
    const { setOrigin } = useItemsContext();
    const { items, setItems } = useItemsContext()
    const [showModalPayer, setShowModalPayer] = useState(false)
    const [pagador, setPagador] = useState('')
    const [dataPayerError, setDataPayerError] = useState(false);
    const [relatedModalOpen, setRelatedModalOpen] = useState(false)
    const [customerWarningModalOpen, setCustomerWarningModalOpen] = useState(false)
    const [foreignCustomerModalOpen, setForeignCustomerModalOpen] = useState(false)
    const [relatedInvoices, setRelatedInvoices] = useState<any[]>([])
    const [showErrorMultipleCompanies, setShowErrorMultipleCompanies] = useState(false)
    const [selectedCompanies, setSelectedCompanies] = useState<Array<{ bplId: number; id: number; serviceName: string }>>([])
    const [redirectFor, setRedirectFor] = useState<'nf' | 'payment' | ''>('')
    
    // Hook customizado para validação de Business Partner
    const { validateBusinessPartner, isBusinessPartnerError, resetBusinessPartnerError } = useBusinessPartner()

    useEffect(() => {
        if (props?.executeFunction == 'nf') {
            showNfProcess({
                ignoreBplids: true
            })
        }

        if (props?.executeFunction == 'payment') {
            showPaymentProcess({
                ignoreBplids: true
            })
        }
    }, [props?.executeFunction]);

    useEffect(() => {
        resetBusinessPartnerError()
    }, [props.selectedItems])

    const getRelatedInvoices = async () => {
        const scheduleIds = props.selectedItems.map( item => item.id )
        const invoiceNumbers = props.selectedItems.map( item => item.invoiceNumber )
        const related = await customer.relatedInvoices.execute({
            scheduleIds: scheduleIds,
            invoiceNumbers: invoiceNumbers
        })
        
        return related.map((item) => ({
            ...item,
            value: money.formatCurrency(item?.value),
            total: money.formatCurrency(item?.total),
            amountPaid: money.formatCurrency(item?.amountPaid),
            amountFeesTable: money.formatCurrency(item?.amountFeesTable),
            amountSpecialHourFeesTable: money.formatCurrency(item?.amountSpecialHourFeesTable),
            procedureDate: date.formatCurrency(item?.procedureDate),
            scheduleDate: date.formatCurrency(item?.scheduleDate),
            status: formatStatus(item?.status),
            taxNoteNumber: formatTaxNoteNumber(item?.taxNoteNumber),
        }));
    }

    const getStringRelatedInvoice = () => {
        return relatedInvoices.map((related, index) => (
            <span key={index}>
            [<b>{related.id}</b>] <b>{related.patient.toUpperCase()}</b>
            <br />
            </span>
        ));
    };


    const validarTomadoresInvalidos = () => {
        const invalids = props.selectedItems.filter(item => 
            !item?.paymentCustomer?.name?.trim() ||
            !item?.paymentCustomer?.registry_code?.trim() ||
            !item?.paymentCustomer?.city?.trim() ||
            (item?.paymentCustomer?.id <= 0) ||
            !item?.paymentCustomer?.neighborhood?.trim() ||
            !item?.paymentCustomer?.state?.trim() ||
            !item?.paymentCustomer?.street?.trim() ||
            !item?.paymentCustomer?.zipcode?.trim() ||
            !item?.paymentCustomer?.number?.trim()
        )
        //Detectar possiveis tomadores inválidos
        if(invalids && invalids.length > 0){
            return true
        }
        //Validação para itens antecipados
        const antecipado = props.selectedItems.filter(item => item.checkIn === null).length
        if (antecipado >= 1) {       
            return true
        }
        return false
    }

    const verificarTomadorEstrangeiro = () => {
        const foreignCustomers = props.selectedItems.filter(item => {
            const nationality = item?.paymentCustomer?.nationality?.toUpperCase()
            return nationality && nationality !== 'BR' && nationality?.trim() !== '' && nationality !== null && !item?.paymentCustomer?.registry_code?.trim()
        })
        return foreignCustomers.length > 0
    }
    
    const handleSubmitFromRelatedInvoicesModal = () => {
        const allItems = [...props.selectedItems, ...relatedInvoices];
        props.setSelectedItems(allItems);
        setOrigin('payment')
        setItems(allItems)
        
        // Verificar tomador estrangeiro após confirmar lote
        const hasForeignCustomer = allItems.some(item => {
            const nationality = item?.paymentCustomer?.nationality?.toUpperCase()
            return nationality && nationality !== 'BR' && nationality?.trim() !== '' && nationality !== null && !item?.paymentCustomer?.registry_code?.trim()
        });
        
        if (hasForeignCustomer) {
            setForeignCustomerModalOpen(true);
        } else {
            setShowModalPayer(true);
        }
    }
    
    const handleSubmitFromCustomerWarningModal = () => {
        if (props.selectedItems.length > 1)
            setShowModalPayer(true)
        else
            navigate('/paymentprocess', { 
                state: { 
                    paymentCustomer: props.selectedItems[0]?.paymentCustomer
                } 
            })
    }

    const handleSubmitFromForeignCustomerModal = () => {
        setForeignCustomerModalOpen(false)
        setShowModalPayer(true)
    }

    const verifyBPLIDS = async () => {
        try {
            const scheduleIds = props.selectedItems.map(item => item.id)

            if (scheduleIds.length === 0) {
                return false
            }
            Notification.waiting({
                message: 'Verificando informações do procedimento... Por favor, aguarde...',
                duration: 3,
            })
            const res = await cataGadp.verifyBatch.execute(scheduleIds)
            const results = res?.bplidassignedToInvoice || []
            if (results.length === 0 || results.map(item => item.bplidassignedToInvoice).includes(null)) {
                Notification.error({
                    message: 'Falha ao verificar BPLID dos procedimentos!',
                    duration: 3,
                })
                throw new Error('Não é possível realizar o pagamento de itens com BPLID inválido!')
            }
            const resultMap = new Map<number, number>()

            results.forEach((item) => {
                const bplId = typeof item.bplidassignedToInvoice === 'string'
                    ? parseInt(item.bplidassignedToInvoice, 10)
                    : (item.bplidassignedToInvoice as number) || 0
                resultMap.set(Number(item.schedule_id), bplId)
            })

            const uniqueBplIds = [...new Set(results.map(r => {
                const bplId = typeof r.bplidassignedToInvoice === 'string'
                    ? parseInt(r.bplidassignedToInvoice, 10)
                    : (r.bplidassignedToInvoice as number) || 0
                return bplId
            }))].filter(id => id > 0)

            const bplIdToServiceName: Record<number, string> = {}
            for (const bplId of uniqueBplIds) {
                try {
                    const serviceInfo = await cataGadp.getServiceInfo.execute(bplId)
                    bplIdToServiceName[bplId] = serviceInfo?.serviceName || `Empresa (ID: ${bplId})`
                } catch {
                    bplIdToServiceName[bplId] = `Empresa (ID: ${bplId})`
                }
            }

            const companyWithNames = scheduleIds
                .map(id => ({ id, bplId: resultMap.get(id) ?? 0 }))
                .filter(({ bplId }) => bplId > 0)
                .map(({ bplId, id }) => ({
                    bplId,
                    id,
                    serviceName: bplIdToServiceName[bplId] || `Empresa (ID: ${bplId})`,
                }))

            setSelectedCompanies(companyWithNames)

            if (uniqueBplIds.length > 1) {
                setShowErrorMultipleCompanies(true)
                return true
            }
            return false
        } catch (error) {
            Notification.error({
                message: 'Falha ao verificar BPLID dos procedimentos!',
                duration: 3,
            })
            throw error
        }
    }

    const selectCompanyByBplId = (bplId: number) => {
        const idsToRemove = selectedCompanies
            .filter((item) => item.bplId !== bplId)
            .map((item) => item.id)

        if (idsToRemove.length > 0) {
            props.removeItem(idsToRemove, redirectFor)
        }

        Notification.success({
            message: `Itens da empresa selecionados com sucesso!`,
            duration: 3,
        })

        setShowErrorMultipleCompanies(false)
    }

    const showPaymentProcess = async (payload?: any) => {
        try {
            setIsLoading(true)
        setRelatedInvoices([])
        
        const itemsByCnpj: Record<string, any[]> = {};
        const cpfItems: any[] = [];
        
        props.selectedItems.forEach(item => {
            const documentoLimpo = normalizeCnpj(item.paymentCustomer?.registry_code ?? '');
            
            if (!isCnpjLength(documentoLimpo)) {
                cpfItems.push(item);
            } else {
                if (!itemsByCnpj[documentoLimpo]) {
                    itemsByCnpj[documentoLimpo] = [];
                }
                itemsByCnpj[documentoLimpo].push(item);
            }
        });
        
        // Validar cada CNPJ único uma vez
        const cnpjValidationPromises = Object.entries(itemsByCnpj).map(async ([cnpj, items]) => {
            const pc = items[0].paymentCustomer;
            const success = await validateBusinessPartner({
                name: pc.name,
                document: pc.registry_code,
                scheduleId: items.map(i => i.id).join(','),
                address: {
                    street: pc.street,
                    number: pc.number,
                    zipcode: pc.zipcode,
                    neighborhood: pc.neighborhood,
                    city: pc.city,
                    state: pc.state,
                    country: pc.country || 'BR',
                },
                options: {
                    buttonType: 'payment',
                    itemIds: items.map(i => i.id),
                    showNotification: false,
                    totalSelected: props.selectedItems.length,
                }
            });
            
            return { cnpj, items, success };
        });
        
        const cnpjResults = await Promise.all(cnpjValidationPromises);
        
        // Construir array de resultados final
        const results: Array<{ id: number; success: boolean }> = [];
        
        // CPFs sempre são válidos
        cpfItems.forEach(item => {
            results.push({ id: item.id, success: true });
        });
        
        // CNPJs - aplicar resultado para todos os items daquele CNPJ
        cnpjResults.forEach(({ items, success }) => {
            items.forEach(item => {
                results.push({ id: item.id, success });
            });
        });
        
        const itemsWithCnpjNotFound = results
            .filter(result => !result.success)
            .map(result => result.id);
        
        if (itemsWithCnpjNotFound.length > 0) {
            const errorMsg = getNotFoundMessage(itemsWithCnpjNotFound, props.selectedItems.length);
            Notification.error(errorMsg);
            return;
        }
        
        const itemsWithZeroTotal = props.selectedItems.filter(item => {
            return item?.total.replace(/\D/g, '') === '000';
        })

        if (props.selectedItems.filter(item => item?.schedulePaymentTypeId === 5).length > 0) {
            Notification.error
            ({
                message: 'Não é possível realizar o Pagamento para items em Cortesia!',
                duration: 3,
            })

            return
        }

        if (itemsWithZeroTotal.length > 0) {
            Notification.error({
                message: 'Não é possível realizar o Pagamento com valor zerado!',
                duration: 3,
            });
            return;
        }
            
        if (props.selectedItems.filter(item => item?.statusBilling === 'paid').length > 0) {
            Notification.error({
                message: 'Não é possível realizar o Pagamento de Itens já pagos!',
                duration: 3,
            })
            return
        }
            
        if (props.selectedItems.filter(item => item?.status === 'CANCELADO').length > 0) {
            Notification.error({
                message: 'Não é possível realizar o Pagamento de Item Cancelado!',
                duration: 3,
            })
            return
        }

        if (props.selectedItems.filter(item => item?.statusBilling === 'pending').length > 0) {
            Notification.error ({
                message: 'Não é possível realizar o Pagamento de Itens com pagamentos pendentes!',
                duration: 3,
            })
            return
        }

        // Tomador precisa estar preenchido (já estará quando a NF for emitida antes, e agora é obrigatório para pagamentos antecipados/lote)

        const itemsWithIncompleteData = props.selectedItems.filter(
            item => item?.paymentCustomer?.id === 0
        );
        
        const hasIncompleteData = itemsWithIncompleteData.length > 0;
        
        if (hasIncompleteData) {
            const ids = itemsWithIncompleteData.map(item => item.id);
        
            Notification.error({
                message: 'Dados do tomador incompletos',
                description: `Por favor, preencha os dados do tomador da NF antes de seguir para pagamento.\nID's: ${ids.join(', ')}`,
                duration: 3,
            });
        
            return;
        }

        if (props.selectedItems.length > 1) {
            //Validação para itens antecipados
            const antecipado = props.selectedItems.filter(item => item.checkIn === null).length
            if (antecipado >= 1) {
                Notification.error({
                    message: 'Pagamento Antecipado',
                    description: `Não é possível realizar o Pagamento Antecipado de mais de 1 item!`,
                    duration: 3,
                })
                return
            }

            //Validação status NF            
            if (props.selectedItems.some(item => item.statusInvoice === 'Pendente Emissao')){
                Notification.error
                ({
                    message: `Status NF`,
                    description: 'Não é possível realizar o pagamento de itens com status de nota fiscal pendente de emissão',
                    duration: 3,
                })
                return     
            }

            //valida número de parcelas
            if (props.selectedItems.some(item => item.paymentInstallmentsNumber !== props.selectedItems[0].paymentInstallmentsNumber)){
                Notification.error
                ({
                    message: `Parcelas diferentes`,
                    description: 'Não é possível realizar o pagamento de itens com número de parcelas diferentes',
                    duration: 3,
                })
                return     
            }

            //valida parcelas
            if (props.selectedItems.some(item => item.paymentInstallmentsNumber !== props.selectedItems[0].paymentInstallmentsNumber)){
                Notification.error
                ({
                    message: `Parcelas diferentes`,
                    description: 'Não é possível realizar o pagamento de itens com número de parcelas diferentes',
                    duration: 3,
                })
                return     
            }

            //Validar se métodos de pagamentos são iguais (caso nota emitida)
            if (props.selectedItems[0].invoiceNumber !== '' && props.selectedItems.some(item => item.methodCode !== props.selectedItems[0].methodCode)){
                //Validar status NF
                Notification.error
                ({
                    message: 'Não é possível realizar o pagamento de itens com notas emitidas com métodos de pagamento diferentes',
                    duration: 3,
                })
                return     
            }
        }    

        setRedirectFor('payment')
        if (!payload?.ignoreBplids && await Promise.resolve(verifyBPLIDS())) {
            setShowErrorMultipleCompanies(true)
            return;
        }
        
        //Validar se existem mais procedimentos atrelados a alguma nota selecionada
        const invoices = await getRelatedInvoices()
        setRelatedInvoices(invoices)

        if (props.selectedItems.length === 1) {
            //Set Payer
            props.selectedItems.forEach( item => { item.payerCustomer = {
                id: props.selectedItems[0].paymentCustomer.id,
                name: props.selectedItems[0].paymentCustomer.name,
                email: props.selectedItems[0].paymentCustomer.email,
                registry_code: props.selectedItems[0].paymentCustomer.registry_code,
                code: props.selectedItems[0].paymentCustomer.registry_code,
                address: {
                    zipcode: props.selectedItems[0].paymentCustomer.zipcode,
                    city: props.selectedItems[0].paymentCustomer.city,
                    country: props.selectedItems[0].paymentCustomer.country,
                    neighborhood: props.selectedItems[0].paymentCustomer.neighborhood,
                    state: props.selectedItems[0].paymentCustomer.state,
                    number: props.selectedItems[0].paymentCustomer.number,
                    street: props.selectedItems[0].paymentCustomer.street,
                }
            }})
            //Se tiver notas relacionadas
            if (invoices.length > 0){
                setRelatedModalOpen(true)
                //return
            }else{
                setOrigin('payment')
                setItems(props.selectedItems);
                
                // Verificar tomador estrangeiro para item único
                if (verificarTomadorEstrangeiro()) {
                    setForeignCustomerModalOpen(true);
                } else if(validarTomadoresInvalidos()){
                    setCustomerWarningModalOpen(true)
                }else{
                    navigate('/paymentprocess', 
                        { state: {
                            payer: pagador,
                            paymentCustomer: props.selectedItems[0]?.paymentCustomer
                        }}
                    )
                }         
            }
            //
            
        }
        else if (props.selectedItems.length > 1) {
            if (props.selectedItems.some(item => item.receiverName !== props.selectedItems[0].receiverName)){
                //Tomadores diferentes
                props.selectedItems.forEach( item => { item.payerCustomer = undefined })
            }else{
                //Tomadores iguais
                props.selectedItems.forEach( item => { item.payerCustomer = {
                    id: props.selectedItems[0].paymentCustomer.id,
                    name: props.selectedItems[0].paymentCustomer.name,
                    email: props.selectedItems[0].paymentCustomer.email,
                    registry_code: props.selectedItems[0].paymentCustomer.registry_code,
                    code: props.selectedItems[0].paymentCustomer.registry_code,
                    address: {
                        zipcode: props.selectedItems[0].paymentCustomer.zipcode,
                        city: props.selectedItems[0].paymentCustomer.city,
                        country: props.selectedItems[0].paymentCustomer.country,
                        neighborhood: props.selectedItems[0].paymentCustomer.neighborhood,
                        state: props.selectedItems[0].paymentCustomer.state,
                        number: props.selectedItems[0].paymentCustomer.number,
                        street: props.selectedItems[0].paymentCustomer.street,
                    }
                }})
            }
            if (invoices.length > 0){
                setRelatedModalOpen(true)
                //return
            }else{
                setOrigin('payment')
                setItems(props.selectedItems)
                
                // Verificar tomador estrangeiro para múltiplos itens
                if (verificarTomadorEstrangeiro()) {
                    setForeignCustomerModalOpen(true);
                } else if(validarTomadoresInvalidos()){
                    setCustomerWarningModalOpen(true)
                }else{
                    setShowModalPayer(true)
                }  
                
            }
            
        }      
        } catch (error) {
            Notification.error({
                message: 'Falha ao solicitar o pagamento, tente novamente!',
                duration: 3,
            })
            throw error
        } finally {
            setIsLoading(false)
        }
    }

    const showNfProcess = async (payload?: any) => {
        try {
            setIsLoading(true)
        if (props.selectedItems.some(item => item.receiverName !== props.selectedItems[0].receiverName)) {
            Notification.error({
                message: 'Não é possível solicitar a emissão em lote com tomadores diferentes!',
                duration: 5,
            });
            return;
        }

        // Agrupar items por CNPJ para validar cada CNPJ único apenas uma vez
        const itemsByCnpj: Record<string, any[]> = {};
        const cpfItems: any[] = [];
        
        props.selectedItems.forEach(item => {
            const documentoLimpo = normalizeCnpj(item.paymentCustomer?.registry_code ?? '');
            
            if (!isCnpjLength(documentoLimpo)) {
                cpfItems.push(item);
            } else {
                if (!itemsByCnpj[documentoLimpo]) {
                    itemsByCnpj[documentoLimpo] = [];
                }
                itemsByCnpj[documentoLimpo].push(item);
            }
        });
        
        // Validar cada CNPJ único uma vez
        const cnpjValidationPromises = Object.entries(itemsByCnpj).map(async ([cnpj, items]) => {
            const pc = items[0].paymentCustomer;
            const success = await validateBusinessPartner({    
                name: pc.name,
                document: pc.registry_code,
                scheduleId: items.map(i => i.id).join(','),
                address: {
                    street: pc.street,
                    number: pc.number,
                    zipcode: pc.zipcode,
                    neighborhood: pc.neighborhood,
                    city: pc.city,
                    state: pc.state,
                    country: pc.country || 'BR',
                },
                options: {
                    buttonType: 'nf',
                    itemIds: items.map(i => i.id),
                    showNotification: false,
                    totalSelected: props.selectedItems.length,
                }
            });
            
            return { cnpj, items, success };
        });
        
        const cnpjResults = await Promise.all(cnpjValidationPromises);
        
        // Construir array de resultados final
        const results: Array<{ id: number; success: boolean }> = [];
        
        // CPFs sempre são válidos
        cpfItems.forEach(item => {
            results.push({ id: item.id, success: true });
        });
        
        // CNPJs - aplicar resultado para todos os items daquele CNPJ
        cnpjResults.forEach(({ items, success }) => {
            items.forEach(item => {
                results.push({ id: item.id, success });
            });
        });
        
        const itemsWithCnpjNotFound = results
            .filter(result => !result.success)
            .map(result => result.id);
        
        if (itemsWithCnpjNotFound.length > 0) {
            const errorMsg = getNotFoundMessage(itemsWithCnpjNotFound, props.selectedItems.length);
            Notification.error(errorMsg);
            return;
        }

        const itemsWithZeroTotal = props.selectedItems.filter(item => {
            return item?.total.replace(/\D/g, '') === '000';
        })

        if (itemsWithZeroTotal.length > 0) {
            Notification.error({
                message: 'Não é possível solicitar NF com valor zerado!',
                duration: 3,
            });
            return;
        }

        if (props.selectedItems.filter(item => item?.schedulePaymentTypeId === 5).length > 0) {
            Notification.error
                ({
                    message: 'Não é possível emitir a NF para items em Cortesia!',
                    duration: 3,
                })

            return
        }

        const procedimentosEmAberto = props.selectedItems.filter(item => item.checkIn === null || item.checkOut === null).length

        if (procedimentosEmAberto > 0) {
            Notification.error
                ({
                    message: 'Não é possível emitir a NF com procedimentos em aberto!',
                    duration: 5,
                })

            return
        }

        if (props.selectedItems.filter(item => item?.status === 'CANCELADO').length > 0) {

            Notification.error
                ({
                    message: 'Não é possível solicitar NF para Item Cancelado!',
                    duration: 3,
                })

            return
        }

        if (props.selectedItems.filter(item => item?.advancePayment === true && item?.billingId > 1 && item?.statusBilling !== 'canceled' && item?.statusBilling !== 'cancelled').length > 0) {

            Notification.error
                ({
                    message: 'Não é possível solicitar NF para Item com Pagamento Antecipado!',
                    duration: 3,
                })

            return
        }

        if (props.selectedItems.filter(item => item?.statusBilling === 'pending').length > 0) {
            Notification.error ({
                message: 'Não é possível solicitar nota fiscal de Itens com pagamentos pendentes!',
                duration: 3,
            })
            return
        }

        if(props.selectedItems.filter(item => item?.surgeon === '' || item?.surgeon === null || item?.surgeon === undefined).length > 0){
            Notification.error({
                message: 'Não é possível solicitar nota fiscal sem cirurgião atribuído!',
                duration: 3,
            })
            return
        }

        if (
            props.selectedItems.filter(item => item?.statusInvoice === 'Solicitado').length > 0 ||
            props.selectedItems.filter(item => item?.statusInvoice === 'Emitido').length > 0 ||
            props.selectedItems.filter(item => item?.statusInvoice === 'Pendente Emissao').length > 0
        ) {

            Notification.error
                ({
                    message: 'Não é possível solicitar NF para itens já enviados!',
                    duration: 3,
                })

            return
        }

        const paided = props.selectedItems.filter(item => item?.statusBilling === 'paid' && item?.statusInvoice === 'allpending').length

        if (paided > 0) {
            Notification.error ({
                message: 'A nota fiscal será emitida automaticamente pois o pagamento já foi realizado!',
                duration: 3,
            })
            return
        }

        setRedirectFor('nf')
        if (!payload?.ignoreBplids && await Promise.resolve(verifyBPLIDS())) {
            setShowErrorMultipleCompanies(true)
            return;
        }

        if (props.selectedItems.length > 0) {
            setOrigin('payment')
            setItems(props.selectedItems);
            navigate(`/nfprocess`);
        }
        } catch (error) {
            Notification.error({
                message: 'Falha ao enviar a solicitação, tente novamente!',
                duration: 3,
            })
            throw error
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div style={{ marginTop: 20 }}>
            <Modal
                open={showErrorMultipleCompanies}
                centered={true}
                closable={true}
                onCancel={() => setShowErrorMultipleCompanies(false)}
                footer={[...new Set(selectedCompanies.map(c => c.bplId))].filter(bplId => bplId > 0).map((bplId) => {
                    const serviceName = selectedCompanies.find(c => c.bplId === bplId)?.serviceName || `Empresa (ID: ${bplId})`
                    return (
                        <Button
                            key={bplId}
                            text={serviceName}
                            onClick={() => selectCompanyByBplId(bplId)}
                        />
                    )
                })}
                title={<h2 style={{ textAlign: 'center', fontSize: '1.5rem' }}>Aviso</h2>}
            >
                <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                    <p style={{ fontSize: '1.1rem', margin: '5px 0' }}>
                        Os agendamentos selecionados estão sendo faturados em empresas diferentes.
                    </p>
                    <p style={{ fontSize: '1.1rem', margin: '5px 0' }}>
                        Por favor, selecione uma empresa para prosseguir com os agendamentos da mesma.
                    </p>
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                        gap: '20px',
                        marginTop: '25px',
                        marginBottom: '20px',
                    }}
                >
                    {[...new Set(selectedCompanies.map(c => c.bplId))].filter(bplId => bplId > 0).map((bplId) => {
                        const serviceName = selectedCompanies.find(c => c.bplId === bplId)?.serviceName || `Empresa (ID: ${bplId})`
                        return (
                            <div
                                key={bplId}
                                style={{
                                    textAlign: 'center',
                                    minWidth: '120px',
                                    border: '1px solid #ccc',
                                    borderRadius: 8,
                                    padding: '10px 15px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                            >
                                <h3 style={{ fontSize: '1.2rem', marginBottom: '10px' }}>
                                    {serviceName}
                                </h3>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0, textAlign: 'left', alignSelf: 'stretch' }}>
                                    {selectedCompanies
                                        .filter((item) => item.bplId === bplId)
                                        .map((item) => (
                                            <li key={item.id}>{item.id}</li>
                                        ))}
                                </ul>
                            </div>
                        )
                    })}
                </div>
            </Modal>

            <Row justify="end">
                {/*
                <Button
                    style={{
                        borderRadius: 20,
                        color: '#FFFFFF',
                        backgroundColor: props.nfNumber !== 0 ? '#FF6D6D' : '#BABBAF',
                        border: '1px solid #FFFFFF',
                        boxShadow: props.nfNumber !== 0 ? '0 0 0 5px #FF6D6D' : '0 0 0 5px #BABBAF',
                        width: 200,
                        marginRight: 20
                    }}
                >
                    Cancelar NF
                </Button>
                */}

                <Button
                    disabled={props.selectedItems.length === 0 || isLoading}
                    text="Solicitar Nota Fiscal"
                    loading={isLoading}
                    nativeProps={{
                        ghost: true,
                        style: { marginRight: 10 }
                    }}
                    onClick={() => showNfProcess()}
                />

                <Button
                    text="Efetuar Pagamento"
                    disabled={props.selectedItems.length === 0 || isLoading}
                    loading={isLoading}
                    onClick={() => showPaymentProcess()}
                />
            </Row>
            <Payer
                visible={showModalPayer}
                setVisible={setShowModalPayer}
                setDataPayerError={setDataPayerError}
                dataPayerError={dataPayerError}
                data={props.selectedItems}//{itemBase}
                allData={items}//{items}
                setReload={() => {}}
                setItemBase={() => {}}
                setPagador={setPagador}
                customers={props.selectedItems.map(item => item.paymentCustomer)}
            />
            <AntModal
                data-testid="modal-form"
                destroyOnClose={true}
                forceRender
                title={
                    <Typography.Title style={{fontSize: 22}}>
                        Agendamentos com NF Emitida em Lote
                    </Typography.Title>
                }
                open={relatedModalOpen}
                centered={true}
                onOk={() => setRelatedModalOpen(false)}
                onCancel={() => setRelatedModalOpen(false)}
                footer={[
                    <AntdButton
                        key="SALVAR1"
                        //type="primary"
                        htmlType="submit"
                        size="middle"
                        //loading={loading}
                        onClick={() => setRelatedModalOpen(false)}
                    >
                        Cancelar
                    </AntdButton>,
                    <AntdButton
                        key="SALVAR"
                        type="primary"
                        htmlType="submit"
                        size="middle"
                        //loading={loading}
                        onClick={() => {setRelatedModalOpen(false);handleSubmitFromRelatedInvoicesModal()}}
                    >
                        Continuar
                    </AntdButton>,
                ]}
            >
                <Typography.Paragraph>
                    Você selecionou um item com Nota emitida em Lote, para seguir com o pagamento é necessário adicionar os seguintes itens
                </Typography.Paragraph>
                {<br></br>}
                {getStringRelatedInvoice()}
                {<br></br>}
                Se continuar, os procedimentos acima serão automaticamente selecionados e direcionados para a tela de pagamento. Deseja prosseguir?
            </AntModal>
            {/* */}
            <AntModal
                data-testid="modal-form"
                destroyOnClose={true}
                forceRender
                title={
                    <Typography.Title style={{fontSize: 22, marginTop: 20}}>
                        Aviso: Dados do Tomador
                    </Typography.Title>
                }
                open={customerWarningModalOpen}
                centered={true}
                onOk={() => setCustomerWarningModalOpen(false)}
                onCancel={() => setCustomerWarningModalOpen(false)}
                footer={[
                    <AntdButton
                        key="SALVAR1"
                        //type="primary"
                        htmlType="submit"
                        size="middle"
                        //loading={loading}
                        onClick={() => setCustomerWarningModalOpen(false)}
                    >
                        Cancelar
                    </AntdButton>,
                    <AntdButton
                        key="SALVAR"
                        type="primary"
                        htmlType="submit"
                        size="middle"
                        disabled={isBusinessPartnerError}
                        //loading={loading}
                        onClick={() => {setCustomerWarningModalOpen(false);handleSubmitFromCustomerWarningModal()}}
                    >
                        Continuar
                    </AntdButton>,
                ]}
            >
                <Typography.Paragraph>
                    Após efetuar o pagamento, não será possível editar os dados do tomador. {isBusinessPartnerError ? '' : 'Deseja prosseguir?'}
                    {isBusinessPartnerError && (
                        <Typography.Paragraph>
                            {getNotFoundMessage().message}<br/>{getNotFoundMessage().description}
                        </Typography.Paragraph>
                    )}
                </Typography.Paragraph>
                {/* {<br></br>}
                {getStringCustomerWarning()}
                {<br></br>} */}
            </AntModal>

            <AntModal
                data-testid="modal-form"
                destroyOnClose={true}
                forceRender
                title={
                    <Typography.Title style={{fontSize: 18, marginTop: 20}}>
                        Tomador estrangeiro
                    </Typography.Title>
                }
                open={foreignCustomerModalOpen}
                centered={true}
                onOk={() => setForeignCustomerModalOpen(false)}
                onCancel={() => setForeignCustomerModalOpen(false)}
                footer={[
                    <AntdButton
                        key="CANCELAR"
                        //type="primary"
                        htmlType="submit"
                        size="middle"
                        //loading={loading}
                        onClick={() => setForeignCustomerModalOpen(false)}
                    >
                        Cancelar
                    </AntdButton>,
                    <AntdButton
                        key="OK"
                        type="primary"
                        htmlType="submit"
                        size="middle"
                        //loading={loading}
                        onClick={() => {setForeignCustomerModalOpen(false);handleSubmitFromForeignCustomerModal()}}
                    >
                        OK
                    </AntdButton>,
                ]}
            >
                <Typography.Paragraph>
                    Para prosseguir com o pagamento, é necessário que o pagador possua um CPF/CNPJ válido.
                </Typography.Paragraph>
            </AntModal>
        </div>
    )
}

export default ButtonsBar
